import { create } from "zustand";
import { devtools } from "zustand/middleware";
import costLinesService from "../api/service/costLinesService";

export const useCostLinesStore = create()(
  devtools((set) => ({
    costLines: [],
    costLinesState: {},
    costLinesStack: [],
    setCostLines: (costLines) => set({ costLines }),
    updateCostLine: (newCostLine) => {
      set((state) => ({
        costLines: [...state.costLines].map((currentCostLine) => {
          if (
            newCostLine?.unique_id === currentCostLine?.unique_id ||
            newCostLine?.id === currentCostLine?.id
          ) {
            return {
              ...currentCostLine,
              ...newCostLine,
            };
          } else {
            return currentCostLine;
          }
        }),
      }));
    },
    // TODO unify with updateCostLine 👆
    updateCostLineById: (id, payload) => {
      set((state) => ({
        costLines: [...state.costLines].map((costLine) => {
          if (costLine.id === id) {
            return { ...costLine, ...payload };
          }
          return costLine;
        }),
      }));
    },
    deleteCostLine: async (id) => {
      const isStored = !id.toString().startsWith("initial");
      useCostLinesStore.setState((state) => ({
        costLinesState: {
          ...state.costLinesState,
          [id]: { ...state.costLinesState[id], isDeleting: true },
        },
      }));
      const filterCostLines = () =>
        set((state) => ({
          costLines: [...state.costLines].filter(
            (costLine) => costLine.id !== id
          ),
        }));

      if (isStored) {
        const response = await costLinesService.deleteCostLine(id);
        if (response?.status === 200) {
          filterCostLines();
        }
      } else {
        filterCostLines();
      }
    },
    addCostLine: (defaultValues = {}) => {
      // ! Unique id, also initial id must be exactly 20 characters long
      const initialCostLineId = `initial${Math.random()}`.slice(0, 20);
      useCostLinesStore.setState((state) => ({
        costLinesState: {
          ...state.costLinesState,
          [initialCostLineId]: { isModified: false },
        },
      }));
      set((state) => ({
        costLines: [
          ...state.costLines,
          {
            id: initialCostLineId,
            unique_id: initialCostLineId,
            request_id: "",
            cost_type_id: "",
            cost_centre: "",
            payment_method_id: "",
            currency_code: "",
            internal_order_id: null,
            amount: "",
            purchase_date: null,
            name: "null",
            description: "",
            payment_method_type: "",
            created_at: "",
            updated_at: "",
            attachments: {
              data: [],
            },
            ...defaultValues,
          },
        ],
      }));
    },

    updateCostLineState: (id, newState) => {
      set((state) => ({
        costLinesState: {
          ...state.costLinesState,
          [id]: { ...state.costLinesState[id], ...newState },
        },
      }));
    },
    clearCostLineState: (id) => {
      set((state) => ({
        costLinesState: Object.fromEntries(
          Object.entries(state.costLinesState).filter(([key, _]) => key !== id)
        ),
      }));
    },

    addCostLineToStack: (costLine) => {
      set((state) => ({
        costLinesState: {
          ...state.costLinesState,
          [costLine.id]: {
            ...state.costLinesState[costLine.id],
            isSaving: true,
          },
        },
        costLinesStack: [...state.costLinesStack, costLine],
      }));
    },
    clearCostLinesStack: () => {
      set((state) => ({
        costLinesState: Object.fromEntries(
          Object.entries(state.costLinesState).map(([id, state]) =>
            state.isSaving ? [id, { ...state, isSaving: false }] : [id, state]
          )
        ),
        costLinesStack: [],
      }));
    },
    resetCostLinesState: () => set({ costLinesState: {} }),
  }))
);
